module.exports = __webpack_public_path__ + "static/media/samady.71c29456.jpeg";